export default __webpack_public_path__ + "static/media/element_57.f9d0fc8e.webp";